import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ScheduleType } from '@core/api';
import { Flex, Select, useForm, zodResolver } from '@coveord/plasma-mantine';
import { Locales } from '../../strings/Locales.js';
import { FrequencyFormProvider, useFrequencyForm } from './FrequencyContext.js';
import { FrequencySchema } from './FrequencySchema.js';
import { DailyFrequency, HourlyFrequency, MinutelyFrequency, MonthlyFrequency, WeeklyFrequency } from './FrequencySubComponents.js';
import { DEFAULT_VALUES_TYPE } from './FrequencySelectorConstants.js';
import { FrequencySelectorUtils } from './FrequencySelectorUtils.js';
var _obj;
var subFrequencyComponents = (_obj = {}, _define_property(_obj, ScheduleType.Daily, /*#__PURE__*/ _jsx(DailyFrequency, {})), _define_property(_obj, ScheduleType.Hourly, /*#__PURE__*/ _jsx(HourlyFrequency, {})), _define_property(_obj, ScheduleType.Minutely, /*#__PURE__*/ _jsx(MinutelyFrequency, {})), _define_property(_obj, ScheduleType.Monthly, /*#__PURE__*/ _jsx(MonthlyFrequency, {})), _define_property(_obj, ScheduleType.Weekly, /*#__PURE__*/ _jsx(WeeklyFrequency, {})), _obj);
export var FrequencySelectorContent = function FrequencySelectorContent(param) {
    var allowedTypes = param.allowedTypes;
    var form = useFrequencyForm();
    var availableTypes = FrequencySelectorUtils.getAvailableTypeKeys(allowedTypes);
    return /*#__PURE__*/ _jsxs(Flex, {
        gap: "md",
        children: [
            /*#__PURE__*/ _jsx(Select, _object_spread_props(_object_spread({
                label: Locales.format('FrequencySelector.label'),
                data: availableTypes.map(function(key) {
                    return {
                        value: ScheduleType[key],
                        label: Locales.format("FrequencySelector.type.".concat(ScheduleType[key]))
                    };
                })
            }, form.getInputProps('frequency.type')), {
                onChange: function onChange(type) {
                    form.setFieldValue('frequency', _object_spread({
                        type: type
                    }, DEFAULT_VALUES_TYPE[type]));
                }
            })),
            subFrequencyComponents[form.values.frequency.type]
        ]
    });
};
export var FrequencySelector = function FrequencySelector(param) {
    var value = param.value, onChange = param.onChange, allowedTypes = param.allowedTypes;
    var form = useForm({
        initialValues: {
            frequency: FrequencySelectorUtils.getInitialFrequency(value, allowedTypes)
        },
        onValuesChange: function onValuesChange(values) {
            return onChange === null || onChange === void 0 ? void 0 : onChange(values.frequency);
        },
        validate: zodResolver(FrequencySchema),
        validateInputOnChange: true
    });
    return /*#__PURE__*/ _jsx(FrequencyFormProvider, {
        form: form,
        children: /*#__PURE__*/ _jsx(FrequencySelectorContent, {
            allowedTypes: allowedTypes
        })
    });
};

//# sourceMappingURL=FrequencySelector.js.map